module.exports = __webpack_public_path__ + "static/media/27-5.9f78a9f2.mp3";